import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function LoginError() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const errorCode = searchParams.get('error') || '';
  const message = t(`loginError.${errorCode}`, { defaultValue: t('loginError.fallback') });

  return (
    <div style={{
      minHeight: '100vh',
      background: '#060C16',
      color: '#F0F5F9',
      padding: 24,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
    }}>
      <p style={{ marginBottom: 16 }}>{message}</p>
      <button
        type="button"
        onClick={() => navigate('/es/regularizacion/registro')}
        style={{
          padding: '12px 24px',
          background: '#5189A0',
          color: 'white',
          border: 'none',
          borderRadius: 8,
          cursor: 'pointer',
          fontWeight: 600,
        }}
      >
        {t('loginError.retry')}
      </button>
    </div>
  );
}
